import router from '@/plugins/router';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useCartStore } from '@/stores/cart';

// Concurrent calls answering 401 at once share one navigation to the login page (SP-15244).
// No `.catch()` on purpose: a stale chunk the router refused to reload must keep surfacing.
let loginRedirect = null;

export default (ignoreRedirect) => {
  useAuthStore().logout();
  useAccountStore().clear();
  useCartStore().clear();
  if (!ignoreRedirect && !loginRedirect) {
    loginRedirect = router.push({
      name: 'login.index',
    }).finally(() => {
      loginRedirect = null;
    });
  }
};
